import { Breadcrumbs, Grid, Typography, Link } from "@mui/material";
import { PartnerArrowIcon } from "../../../res/NewWebIcons";

const BreadcrumbsComponent = () => (
  <Grid container alignItems="center">
    <Breadcrumbs
      separator={<PartnerArrowIcon />} // Custom separator
      aria-label="breadcrumb"
      sx={{
        fontFamily: "sans-serif",
        fontSize: "12px",
      }}
    >
      <Link
        underline="hover"
        color="textSecondary"
        href="#"
        sx={{ fontSize: "12px" }}
      >
        Reports
      </Link>
      <Typography color="textPrimary" sx={{ fontSize: "12px" }}>
        Fund Transfer Report
      </Typography>
    </Breadcrumbs>
  </Grid>
);

export default BreadcrumbsComponent;
